import { useMutation } from "@tanstack/react-query"
import {createAxiosWithAuth} from './middleware'

export const useDeleteChat = () =>{   
  const axios = createAxiosWithAuth();

   return useMutation({
      mutationFn: async (query) => {
        return await axios.post('/chat/delete', query)
      },
    })
}